export const ROLES = Object.freeze({
  ADMIN: 'ADMIN',
  EDITOR: 'EDITOR',
  USER: 'USER',
});

export const USER_ROLES_OPTIONS = [
  { label: 'Admin', value: 'admin' },
  { label: 'User', value: 'user' },
];

export const USER_ROLES = {
  ADMIN: 'admin', // Jan-Way Admin
  PRIMARY_ADMIN: 'primary_admin', // User that is the first one assigned to the organization, has the power to create a new organization
  ORGANIZATION_ADMIN: 'organization_admin', // Does not have power to create or edit organization but has power to configure
  MULTIPLE_FACILITY_ADMIN: 'multiple_facility_admin', // Has power to access to multiple faciltiies configuration
  FACILITY_ADMIN: 'facility_administrator', // Has power to access only to one facility configuration
};

export const ORGANIZATION_USER_ROLES = [
  { value: 'primary_admin', label: 'Primary Administrator' },
  { value: 'organization_admin', label: 'Organization Administrator' },
  { value: 'multiple_facility_admin', label: 'Multiple Facility Administrator' },
  { value: 'facility_admin', label: 'Facility Administrator' },
];
